const unwrapResponse = (response) => response?.data && !response.primaryId
  ? response.data
  : response;

export const firstExamResponse = (response) => {
  const unwrapped = unwrapResponse(response);
  return Array.isArray(unwrapped) ? unwrapped[0] : unwrapped;
};

export const getExamQuestionList = (response) => {
  const examResponse = firstExamResponse(response);
  const nestedQuestions = examResponse?.exam?.questionList;
  if (Array.isArray(nestedQuestions) && nestedQuestions.length > 0) {
    return nestedQuestions;
  }

  return Array.isArray(examResponse?.questionList) ? examResponse.questionList : [];
};

export const withExamQuestionList = (response, questionList) => {
  const examResponse = firstExamResponse(response);
  if (!examResponse || !Array.isArray(questionList) || questionList.length === 0) {
    return examResponse;
  }

  return {
    ...examResponse,
    exam: {
      ...(examResponse.exam || {}),
      questionList
    }
  };
};
